/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { BiUserCheck, BiTransfer, BiSearch } from "react-icons/bi";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";

import schema from './filterValidation';
// actions
import {
  resetTabs,
  resetError,
  getTabs,
  deleteTab,
} from "../../store/tabs/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsisSoft from "../../components/Common/BadgesEllipsisSoft";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

import "./tabs.scss";
import { ExtraInputComponent } from "../../components/Common/FilterInput";
import { useForm } from "react-hook-form";

const Tabs = ({ t }) => {
  const dispatch = useDispatch();

  const history = useHistory();

  const qtdDefault = 7;

  const {
    dataTab,
    dataTabDelete,
    loadingTab,
    loadingTabDelete,
    errorTab,
    successTab,
  } = useSelector((state) => state.Tab);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [tabId, setTabId] = useState("");
  const [tabName, setTabName] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [typeSearch, setTypeSearch] = useState(['name']);
  const [isTabInfor, setIsTabInfor] = useState("1");

  const [notFound, setNotFound] = useState(false);

  const optionsInputSearch = [
    {
      value: 'name',
      label: t(`name`),
    },
    {
      value: 'skillName',
      label: t(`skillName`)
    }
  ];

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successTab && dispatch(resetTabs()) && handleFilter(),
  };

  const { register, handleSubmit, errors, setValue, getValues, setError, clearErrors } = useForm();

  const handleSubmitForm = useCallback(async(value) =>{
    console.log('handleSubmitForm: ',value);
    try {
      await schema.validate(value);
    
      setPage(1);
      dispatch(getTabs({ 
        page: 1, 
        qnt: qtdDefault, 
        value: value?.search_tabs?.value, 
        type: value?.search_tabs?.types?.[0], 
        isInformationTab: isTabInfor === '2' 
      }));

      setTypeSearch(value?.search_tabs?.types);

    } catch (error) {

      if(error?.message && error?.path){
        setError(`${error?.path}`, { type: 'custom', message: error?.message });
      }
    }    
  },[]);

  const handleFilter = () => { 
    setPage(1);
    dispatch(getTabs({ 
      page: 1, 
      qnt: qtdDefault, 
      value: nameFilter, 
      type: getValues('search_tabs.types')?.[0] ?? typeSearch[0], 
      isInformationTab: isTabInfor === '2' 
    }));
  };

  const handleDelete = () => {
    dispatch(deleteTab(tabId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setTabIdName = (tab) => {
    setTabId(tab.id);
    setTabName(tab.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getTabs({ 
      page: value, 
      qnt: qtdDefault, 
      value: nameFilter, 
      type: getValues('search_tabs.types')?.[0] ?? typeSearch[0],
      isInformationTab: isTabInfor === '2' 
    }));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataTab && dataTab.paging) {
      if (page < dataTab.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const handleSkillName = (tab) => {
    const listName = dataTab.skills.reduce((acc, item) => {
      const name = tab.skill_id?.find((el) => el === item.id);
      if (name) {
        acc.push({
          id: item.id,
          name: item.name,
        });
      }
      return acc;
    }, []);

    return listName;
  };

  useEffect(() => {
    if (successTab && dataTabDelete && dataTabDelete.message) {
      showToast("success", t(dataTabDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successTab]);

  useEffect(() => {
    if (errorTab && typeof errorTab === "object") {
      errorTab.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Tabs not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorTab) {
        showToast("error", t(errorTab));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorTab]);

  useEffect(() => {
    if (dataTab !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataTab]);

  useEffect(() => {
    handleFilter();
  }, [isTabInfor]);
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/tabs"
            title={t("Dashboard")}
            breadcrumbItem={t("Tabs")}
          />
          <Row>
            <Col xs="12">
              <Card style={{backgroundColor: '#222736'}}>
                <CardBody className="card-height">
                  <form
                    className="content-filter"
                    onSubmit={handleSubmit(handleSubmitForm)}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <ExtraInputComponent
                          labelDropdown={t("Search")}
                          name="search_tabs"
                          type="text"
                          placeholder={t("Enter the search term")}
                          options={optionsInputSearch}
                          register={register}
                          error={errors?.search_tabs}
                          typeInputRadio
                          buttonReset
                          reverteBordeButtonDrop
                          maxLength={60}
                          defaultValueTypes={getValues('search_tabs.types')?.[0] ? getValues('search_tabs.types') : typeSearch} 
                          valueInput={nameFilter} 
                          onChangeInput={(e)=> { 
                            setNameFilter(e?.target?.value);
                            setValue("search_tabs.value", e?.target?.value);
                           }}  
                          onChangeSelect={(value) => { setValue("search_tabs.types", value) }}
                        />
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="d-flex align-items-center pt-0"
                      >
                        <div className={errors?.search_tabs ? "pb-3" : "pt-0"}>
                          <Button
                            type="submit"
                            color={nameFilter?.length === 0 ? "secondary" : "primary"}
                            disabled={nameFilter?.length === 0}
                            className="waves-effect waves-light w-100 mb-3 mr-3"
                          >
                            <BiSearch size={18}/>                          
                          </Button>
                        </div>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-Tab">
                          <Link to={`/tab`}>
                            <Button
                              type="button"
                              color="primary"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Tab")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </form>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Nav tabs>
                        <NavItem>
                          <NavLink
                            className={isTabInfor === '1' ? `active active-tab` : ''}
                            onClick={()=>{ setIsTabInfor('1') }}
                          >
                            <span className={"pr-2"}>
                              <BiUserCheck size={15}/>
                            </span>
                            Padrão
                            <div className={isTabInfor === '1' ? "line-tabs": ''}></div>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={isTabInfor === '2' ? `active active-tab` : ''}
                            onClick={()=>{ setIsTabInfor('2') }}
                          >
                            <span className={"pr-2"}>
                              <BiTransfer size={15}/>
                            </span>
                            Informativa
                            <div className={isTabInfor === '2' ? "line-tabs": ''}></div>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent activeTab={isTabInfor}>
                        <TabPane tabId="1" style={{backgroundColor: '#2a3042'}}>
                          <TableTabs
                            t={t}
                            loadingTab={loadingTab}
                            notFound={notFound}
                            dataTab={dataTab}
                            toggleModal={toggleModal}
                            setTabIdName={setTabIdName}
                            history={history}  
                            handleSkillName={handleSkillName}
                            totalPerPage={qtdDefault}
                            currentPage={page}
                          />
                        </TabPane>
                        <TabPane tabId="2" style={{backgroundColor: '#2a3042'}}>
                          <TableTabs
                            t={t}
                            loadingTab={loadingTab}
                            notFound={notFound}
                            dataTab={dataTab}
                            toggleModal={toggleModal}
                            setTabIdName={setTabIdName}
                            history={history}  
                            handleSkillName={handleSkillName}
                            totalPerPage={qtdDefault}
                            currentPage={page}
                          />
                        </TabPane>
                      </TabContent>                      
                      <Modal isOpen={modal || loadingTabDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the tab")}
                          <strong> {tabName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingTabDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (tabId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataTab?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Tabs);


const TableTabs = ({
  t,
  loadingTab,
  notFound,
  dataTab,
  toggleModal,
  setTabIdName,
  history, 
  handleSkillName, 
  totalPerPage,
  currentPage,
})=>{

  const borderNone = useCallback((el)=>{
    if (el) {
      el.style.setProperty('border', 'none', 'important');
    }
  },[]);

  return(
    <>
    <Table className="table-centered table-nowrap table-borderless table-hover">
      <thead className="">
        <tr>
          <th ref={borderNone} >
            <span className="ml-2">{"#"}</span>
          </th>
          <th ref={borderNone} >{t("Name")}</th>
          <th ref={borderNone} >{t("Skills")}</th>
          <th ref={borderNone} className="text-right pr-4 ">{t("Action")}</th>
        </tr>
      </thead>
      <tbody>
        {loadingTab ? (
          <tr>
            <td colSpan="20" align="center">
              <Spinner
                size="sm"
                animation="border"
                style={{
                  marginTop: "40px",
                  height: "50px",
                  width: "50px",
                }}
              />
            </td>
          </tr>
        ) : notFound ? (
          <tr>
            <td colSpan="20" align="center">
              {t("Click search to show the records")}
            </td>
          </tr>
        ) : dataTab && dataTab.responseTabs && dataTab.responseTabs.length > 0 ? (
          dataTab.responseTabs.map((tab, key) => (
            <tr key={key}>
              <td className="pl-4">{totalPerPage * currentPage - ( totalPerPage - (key + 1) )}</td>
              <td className="column-text-overflow-10">{tab.name}</td>
              <td>
                {tab.global ? (
                  "Global"
                ) : (
                  <BadgesEllipsisSoft objItems={handleSkillName(tab)} />
                )}
              </td>
              <td className="text-right">
                <button
                  disabled={tab?.default}
                  className="text-primary text-center icon_button"
                  id="edit"
                  onClick={() => history.push(`/tab/${tab.id}`)}
                >
                  <span
                    id={`edittooltip${key}`}
                    className="mdi mdi-pencil font-size-18 px-2"
                  ></span>
                  <UncontrolledTooltip
                    placement="auto"
                    target={`edittooltip${key}`}
                  >
                    {t("Edit")}
                  </UncontrolledTooltip>
                </button>

                {/* TODO: add custom styles to css file */}
                <button
                  disabled={tab?.default}
                  className="mdi mdi-window-close text-danger font-size-18 px-2 icon_button"
                  id={`deletetooltip${key}`}
                  onClick={() => {
                    toggleModal();
                    setTabIdName(tab);
                  }}
                >
                  <UncontrolledTooltip
                    placement="auto"
                    target={`deletetooltip${key}`}
                  >
                    {t("Delete")}
                  </UncontrolledTooltip>
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="20" align="center">
              {t("No matching records found")}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    </>
  );
}